<header id="header" class="main-header">
  <div class="logo">
    <img
      class="img-logo"
      src="../../../assets/images/Costa.png"
      alt="Costa Logo"
      (click)="goTo('home')"
    />
  </div>
  <div class="header-right">
    <div class="language_selector">
      <app-language-picker></app-language-picker>
    </div>
    @if (auth.displayName) {
      <div class="user" (click)="op.toggle($event)">
        <div class="bg">
          <div class="name">{{ auth.inizialiNome }}</div>
          <div class="bg2"></div>
        </div>
      </div>
    }
  </div>
</header>
<p-popover #op [styleClass]="'profile-panel'">
  <p>{{ auth.user?.displayName }}</p>
  <p>{{ auth.user?.email }}</p>
  <p-button
    (onClick)="SingOut()"
    severity="secondary"
    label="Logout"
  ></p-button>
</p-popover>
